import React from 'react';
import {isSurveyEditRestrictedSelector} from "../../../../../slices/surveyEditorSlice";
import {useSelector} from "react-redux";

function QuestionEditChoice(props) {
    const surveyEditRestricted = useSelector(isSurveyEditRestrictedSelector);
    const hideErrorCSS = props.questionValid || !props.errorMessage;

    return (
        <div className={"error_container error_container--inputs " + (hideErrorCSS ? "":"error_container--active")}>
            <div className="questionaire__builder__question__inputs__answear">
                {props.isChoiceMatrixRow ?
                    (<span className="questionaire__builder__question__inputs__answear__no__matrix_rows">{props.choiceValue}</span>)
                    :
                    (<span className="questionaire__builder__question__inputs__answear__no">{props.choiceValue}</span>)
                }
                <span className="questionaire__builder__question__inputs__answear__mobile"></span>
                <input type="text"
                       id={props.idChoice}
                       className="questionaire__builder__question__inputs__answear__input"
                       value={props.choiceText}
                       onChange={props.onChange}
                       maxLength={props.maxLength}
                       placeholder=""
                />
                {!surveyEditRestricted ?
                    (<span className="questionaire__builder__question__inputs__answear__move"></span>)
                    :
                    (<span style={{background: "transparent", cursor: "default"}} className="questionaire__builder__question__inputs__answear__move"></span>)
                }
                {props.showRemoveButton && !surveyEditRestricted ?
                    (<span onClick={props.handleRemoveChoice} className="questionaire__builder__question__inputs__answear__delete"></span>)
                    :
                    (<span style={{background: "transparent", cursor: "default"}} className="questionaire__builder__question__inputs__answear__delete"></span>)
                }
            </div>
            <span className="error_container__message">{props.errorMessage}</span>
        </div>
    )
}

export default QuestionEditChoice;